import moment from "moment";

const getBetweenDates = ( startDate, endDate, filterBy ) => {
  return new Promise( ( resolve, reject ) => {
    let dateStart = moment( startDate );
    let dateEnd = moment( endDate );
    let timeValues = [];
  
    if( filterBy === "day" ) {
      while( dateEnd > dateStart || dateStart.format( "D" ) === dateEnd.format( "D" ) ) {
        timeValues.push( dateStart.format( "DD MMM YYYY" ) );
        dateStart.add( 1, "day" );
      } 
      resolve( timeValues );

    } else if( filterBy === "month" ) {
      timeValues.push( { year: parseInt( moment( dateStart ).format( "YYYY" ) ), month: parseInt( moment( dateStart ).format( "MM" ) ) } );
      timeValues.push( { year: parseInt( moment( dateEnd ).format( "YYYY" ) ), month: parseInt( moment( dateEnd ).format( "MM" ) ) } );
      resolve( timeValues );

    } else {
      timeValues.push( { year: parseInt( moment( dateStart ).format( "YYYY" ) ), week: parseInt( moment( dateStart ).format( "WW" ) ) } );
      timeValues.push( { year: parseInt( moment( dateEnd ).format( "YYYY" ) ), week: parseInt( moment( dateEnd ).format( "WW" ) ) } );
      resolve( timeValues );
    }
  } );
};

export default getBetweenDates;